import { useEffect, useState } from "react";
import { useParams } from "react-router-dom-v5-compat";
import { getLocationPageData } from "../OrderFlow/utils/requests";
import { useLogging } from "../Shared/hooks/useLogging/useLogging";
import { LocationPageText } from "./Location-types";
import { locationSorter } from "./locationsUtils";
import { LogLevel } from "../Shared/hooks/useLogging/Logging-types";
export const useLocations = (skipLocationPage) => {
    var _a, _b, _c, _d, _e, _f;
    const { sku: skuParam } = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const [data, setData] = useState(undefined);
    const { datadogLog } = useLogging();
    useEffect(() => {
        // Don't fetch this data if we are skipping the location page
        if (skipLocationPage)
            return;
        setLoading(true);
        getLocationPageData(skuParam)
            .then(({ data }) => {
            var _a, _b;
            if (!data.success) {
                setLoading(false);
                datadogLog((_a = data.message) !== null && _a !== void 0 ? _a : "Error fetching location page data", LogLevel.ERROR);
                setError((_b = data.message) !== null && _b !== void 0 ? _b : "Something went wrong loading this page. Please try again.");
                return;
            }
            setData(data);
            setLoading(false);
        })
            .catch((e) => {
            var _a, _b;
            console.error("Location fetch error", e);
            datadogLog((_a = e.message) !== null && _a !== void 0 ? _a : "Error fetching location page data", LogLevel.ERROR, {}, e);
            setLoading(false);
            setError((_b = e.message) !== null && _b !== void 0 ? _b : "Something went wrong loading this page. Please try again.");
        });
    }, []);
    return {
        loading,
        deliveryMethodMarkdown: data === null || data === void 0 ? void 0 : data.deliveryMethodMarkdown,
        pickupIcon: (_a = data === null || data === void 0 ? void 0 : data.pickupIcon) !== null && _a !== void 0 ? _a : LocationPageText.PICKUP_ICON,
        pickupIconColor: (_b = data === null || data === void 0 ? void 0 : data.pickupIconColor) !== null && _b !== void 0 ? _b : LocationPageText.PICKUP_ICON_COLOR,
        pickUpMarkdown: (_c = data === null || data === void 0 ? void 0 : data.pickUpMarkdown) !== null && _c !== void 0 ? _c : LocationPageText.PICKUP_MARKDOWN,
        pickUpSubtext: data === null || data === void 0 ? void 0 : data.pickUpSubtext,
        deliveryIcon: (_d = data === null || data === void 0 ? void 0 : data.deliveryIcon) !== null && _d !== void 0 ? _d : LocationPageText.DELIVERY_ICON,
        deliveryIconColor: (_e = data === null || data === void 0 ? void 0 : data.deliveryIconColor) !== null && _e !== void 0 ? _e : LocationPageText.DELIVERY_ICON_COLOR,
        deliveryMarkdown: (_f = data === null || data === void 0 ? void 0 : data.deliveryMarkdown) !== null && _f !== void 0 ? _f : LocationPageText.DELIVERY_MARKDOWN,
        deliverySubtext: data === null || data === void 0 ? void 0 : data.deliverySubtext,
        contentArea: data === null || data === void 0 ? void 0 : data.contentArea,
        locations: data === null || data === void 0 ? void 0 : data.pickUpLocations.sort(locationSorter),
        shouldDisplayLocationSection: data === null || data === void 0 ? void 0 : data.shouldDisplayLocationSection,
        shouldDisplayDeliverySection: data === null || data === void 0 ? void 0 : data.shouldDisplayDeliverySection,
        error,
        programId: data === null || data === void 0 ? void 0 : data.programId
    };
};
